import { render, staticRenderFns } from "./CategoryGoodsSetting.vue?vue&type=template&id=10bf7230&scoped=true&"
import script from "./CategoryGoodsSetting.vue?vue&type=script&lang=js&"
export * from "./CategoryGoodsSetting.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGoodsSetting.vue?vue&type=style&index=0&id=10bf7230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf7230",
  null
  
)

export default component.exports